import { gql } from '@apollo/client'

const ALL_AGENCIES = gql`
  query AgenciesQuery {
    agencies_LA {
      data {
        id
        name
        securityKey
      }
    }
  }
`

export { ALL_AGENCIES }
